import { module } from 'modujs';
import { random } from '../utils/maths';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {

        if(window.isMobile) return;

        this.bindClick = this.click.bind(this);
        document.addEventListener('click',this.bindClick);

    }

    click(e) {
        let $kiss = document.createElement('span');
        $kiss.classList.add('c-kiss');

        let randomScale = random(0.5,1);
        $kiss.style.left = `${e.clientX}px`;
        $kiss.style.top = `${e.clientY}px`;

        $kiss.style.transform=`rotate(${random(-45, 45)}deg)`;

        this.el.append($kiss);

        let tl = gsap.timeline();

        tl.fromTo($kiss,{
            scale: 0,
            alpha: 1
        },{
            scale: randomScale,
            alpha: 1,
            duration: 0.4
        });
        tl.to($kiss,{
            scale: 0,
            alpha: 0,
            duration: 0.6,
            delay: 0.4
        })

        gsap.delayedCall(1.6, () => {
            $kiss.parentNode.removeChild($kiss);
        });
        
    }
}
